// tokens.ts
import { InjectionToken } from '@angular/core';
import { Merchant, Order, User } from '@print2go/types';
import { FirestoreCoreService } from '../services/firestore-core.service';

export type CollectionPath = 'users' | 'merchants' | 'orders';

export const MERCHANT_FIRESTORE_SERVICE =
  new InjectionToken<FirestoreCoreService<Merchant, CollectionPath>>('MerchantFirestoreService');
export const USER_FIRESTORE_SERVICE =
  new InjectionToken<FirestoreCoreService<User, CollectionPath>>('UserFirestoreService');
export const ORDER_FIRESTORE_SERVICE =
  new InjectionToken<FirestoreCoreService<Order, CollectionPath>>('OrderFirestoreService');

export const AWESOME_FIRESTORE_PROVIDERS = [
  {
    provide: MERCHANT_FIRESTORE_SERVICE,
    useFactory: () =>
      new FirestoreCoreService<Merchant, CollectionPath>('merchants', 'uid'),
  },
  {
    provide: USER_FIRESTORE_SERVICE,
    useFactory: () =>
      new FirestoreCoreService<User, CollectionPath>('users', 'uid'),
  },
  {
    provide: ORDER_FIRESTORE_SERVICE,
    useFactory: () =>
      new FirestoreCoreService<Order, CollectionPath>('orders', 'id'),
  },
];